import { VStack } from "@chakra-ui/react";
import React from "react";
import { LoginPath, ReferralTokenType } from "../constants/TokenReferralConstants";
import { LoginPathButton } from "./LoginPathButton";

export interface LoginInviteTokenSelectAccountPathProps {
	tokenType: ReferralTokenType
}

/**
 * LoginInviteTokenSelectAccountPath
 * 
 * Handles the flow where a user has an invite token
 * and must select whether to create a new account or login.
 */
export const LoginInviteTokenSelectAccountPath: React.FC<
	LoginInviteTokenSelectAccountPathProps
> = ({ tokenType }) => {

	const introText = () => {
		switch (tokenType) {
			case ReferralTokenType.Rfx:
				{
					return "access a RFx (Request For 'x' tender).";
				}
			case ReferralTokenType.RfxPreApproval:
				{
					return "pre-approve a RFx prior to it being sent to suppliers.";
				}
			case ReferralTokenType.SharedProfile:
				{
					return "view a company profile.";
				}
			case ReferralTokenType.EvaluationPanelMember:
				{
					return "participate in a RFx Evaluation.";
				}
		}
	}

	return (
		<div className="login-invite-token-select-account-path">
			<VStack spacing={4}>
				<div className="text-left text-xl">You have been provided with a referral code to {introText()}</div>
				<LoginPathButton loginPath={LoginPath.Login} />
				<LoginPathButton loginPath={LoginPath.CreateAccount} />
			</VStack>
		</div>
	);
};

export default LoginInviteTokenSelectAccountPath;